import React from 'react';
import useData from '@/utils/useData';
import {Story} from '@/entities/story';
import StoryListView from '@/views/stories/StoryListView';
import {StoryListType} from '@/types/StoryListType';

const PublicStoryboardsListView: React.FC = () => {
    // Use the same approach as the manual menu system
    const [publicStories] = useData<Story[]>(window.URLS.storiesResource, {
        storeResolver: 'publicStories',
        initialValue: [],
        requestParams: {
            params: {storyListType: 'publicStories'},
        },
    });

    // If we have public stories data, use the existing StoryListView
    // Otherwise, show loading or empty state
    if (publicStories && publicStories.length >= 0) {
        return <StoryListView storyListType={StoryListType.PublicStories} />;
    }

    return (
        <div style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            Loading public storyboards...
        </div>
    );
};

export default PublicStoryboardsListView;
